export default __webpack_public_path__ + "static/media/checkbox-unchecked.27c4e81e.png";